import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';
import { BillTo, BillType } from '../../../shared/models/billing/bill-type';
import { Patient } from '../../../shared/models/order-entry/patient';
import { Physician } from '../../../shared/models/order-entry/physician';
import { TreeTest } from '../../../shared/models/order-entry/test';
import { RequisitionAdditionalCopy } from './requisition-additional-copy';
import { RequisitionStatus } from './requisition-search';
import { RequisitionTest } from './requisition-test';
import {AnswerAoe} from "./aoes";

export enum ClinicalInfo {
    Unknown,
    Fasting,
    NonFasting,
}

export class Requisition extends BaseDataTransferObject {
    public patientId?: number;
    public physicianId?: number;
    public code?: string;
    public additionalTestsDxCodes?: string;
    public comments?: string;
    public fasting?: ClinicalInfo;
    public priority?: string;
    public hasSignature?: boolean;
    public collectionDate?: Date | string;
    public billTo?: BillTo;
    public status?: RequisitionStatus;
    public patient?: Patient;
    public physician?: Physician;
    public medications?: number[];
    public diagnoses?: number[];
    public additionalCopies?: RequisitionAdditionalCopy[];
    public tests?: RequisitionTest[];
    public treeTests?: TreeTest[];
    public testAnswers?: AnswerAoe[];
    public testTypeAnswers?: AnswerAoe[];
}
